'use client';

import styles from './VideoPlayer.module.scss';
import { useMediaPlaybackState } from '@/lib/hooks/useMediaPlaybackState';

interface AudioToggleButtonProps {
  videoRef: React.RefObject<HTMLVideoElement | null>;
}

export default function AudioToggleButton({ videoRef }: AudioToggleButtonProps) {
  const { isMuted } = useMediaPlaybackState(videoRef);

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    video.muted = !video.muted;
  };

  return (
    <button
      type="button"
      className={styles.volumeControl}
      onClick={toggleMute}
      aria-pressed={isMuted}
      aria-label="Mute"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Volume bars - 3 vertical bars of increasing height */}
        <rect x="2" y="10" width="3" height="3" fill={isMuted ? "gray" : "currentColor"}/>
        <rect x="7" y="7" width="3" height="6" fill={isMuted ? "gray" : "currentColor"}/>
        <rect x="12" y="4" width="3" height="9" fill={isMuted ? "gray" : "currentColor"}/>
      </svg>
      <p>{isMuted ? "OFF" : "ON"}</p>
    </button>
  );
}
